'use client';

import { observer } from 'mobx-react';
import React from 'react';
import { getStore } from '~/mobx/AppStore';
import { StandAdminUserVote } from '~/definitions/report';

type Props = {
    items: StandAdminUserVote[];
};

const StandVotesReports = (props: Props) => {
    const { items } = props;
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <div className="vote-report mb-4">
            {items.map((item) => {
                const fullName = item?.name || '';
                const title = item.email ? `${fullName} (${item.email})` : fullName;
                if (item.user_count < 1) {
                    return null;
                }
                return (
                    <div key={item.stand_admin_id}>
                        <div className="flex flex-col lg:flex-row">
                            <div className="w-[70%] lg:mb-0">
                                <ul className="leading-[1.75]">
                                    <li>
                                        <span className="font-bold">{item.user_count} </span>
                                        innleverte stemmesedler fra stand
                                        <span className="font-bold"> {title}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const StandVotesReportWithStore = () => {
    const { reportStore } = getStore();
    return <StandVotesReports items={reportStore.standAdminUserVoteList || []} />;
};

export default observer(StandVotesReportWithStore);
